import { Pipe, PipeTransform } from '@angular/core';
import { isMasked } from '@miq/utils';
import { L10nTranslationService } from 'angular-l10n';
import moment from 'moment';
import { MY_FORMATS, NA, Unknown, UTC_EDP_INPUT_FORMAT } from '../constants/date.const';

@Pipe({
  name: 'getDateString',
  standalone: false,
})
export class GetDateString implements PipeTransform {
  constructor(public translationService: L10nTranslationService) {}
  transform(date: string, format = MY_FORMATS): string {
    if (date === Unknown || isMasked(date)) {
      return date;
    }
    const formattedDate = moment.utc(date, UTC_EDP_INPUT_FORMAT);
    return formattedDate.isValid() ? formattedDate.format(format) : NA;
  }
}
